import script from "./TheChip.vue?vue&type=script&setup=true&lang=js"
export * from "./TheChip.vue?vue&type=script&setup=true&lang=js"

import "./TheChip.vue?vue&type=style&index=0&id=f4592238&lang=css"

const __exports__ = script;

export default __exports__